import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type CallbackLeadListItem = ResultOf<
  typeof callbackLeadListQuery
>["callbackLeads"]["data"][number];

export const callbackLeadListQuery = graphql(`
  query CallbackLeadList(
    $page: Int!
    $first: Int!
    $status: [CallbackLeadStatus!]
    $source: [CallbackLeadSource!]
    $regions: [Region!]
    $search: String
    $abandonedFirst: Boolean
    $orderBy: [QueryCallbackLeadsOrderByRelationOrderByClause!]
  ) {
    callbackLeads(
      page: $page
      first: $first
      status: $status
      source: $source
      regions: $regions
      search: $search
      abandonedFirst: $abandonedFirst
      orderBy: $orderBy
    ) {
      data {
        id
        status
        source
        outcome
        note
        name
        email
        phone
        contact_attempts
        calls_count
        calls {
          id
          result
          direction
          dialled_at
        }
        last_contacted_at
        snoozed_until
        became_callable_at
        expires_at
        created_at
        bookings_count
        user {
          id
        }
        waitlist {
          id
          earliest_departure_date
          latest_departure_date
          vehicle_category
          number_of_travellers
          relocationLink
          created_at
          departureCity {
            id
            name
            timezone
          }
          departure_state
          deliveryCity {
            id
            name
          }
          delivery_state
        }
        relocation {
          id
          reference
          customer_url
          available_from_date
          latest_departure_date
          created_at
          departureCity {
            id
            name
            timezone
          }
          deliveryCity {
            id
            name
          }
        }
        booking {
          id
          reference
          name
          currency
          depart_at
          created_at
          charge_summary {
            total_amount
          }
          relocation {
            id
            reference
            customer_url
          }
          departureOffice {
            id
            name
            city {
              id
              timezone
            }
          }
          deliveryOffice {
            id
            name
          }
          supplier {
            id
            name
          }
        }
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
